import React, { FC } from 'react'

import { pluralize } from '@avantstay/backoffice-core'

import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

import { FiltersSharedProps } from './Filters.types'
import { InputBasedFilter } from './FiltersVariations/Input'

interface MinBathroomsFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

export const MinBathroomsFilter: FC<MinBathroomsFilterProps> = props => {
  const { initialValue } = props

  return (
    <InputBasedFilter
      title={filtersLabels.minBathrooms}
      type="number"
      placeholder="0"
      {...props}
      tagSuffix={initialValue && pluralize(parseInt(initialValue, 10), 'bathrooms', 'bathroom')}
    />
  )
}
